import React, { useState, useEffect, useCallback } from 'react';
import WatchMovie from '../../Components/WatchMovie';
import api from '../../Services/api';
import { format } from 'date-fns';
import { useAblContext } from '../../Hooks/useAblContext';
import {getFileFromS3 } from '../../Services/s3';

interface Movie {
  id: string;
  companyName: string;
  url: string;
  movieName: string;
  createDate: Date;
  bucketFilename: string;
}

//Excluir - apenas para logins ADMIN
export default function Movie() {
  const [movies, setMovies] = useState<any[]>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const [movieUrl, setMovieUrl] = useState<string>("")
  const abl = useAblContext();

  useEffect(() => {
    api.get('company/video', {headers: { authorization: abl.token }}).then(response =>{
      console.log(response.data);
      setMovies(response.data);
    }).catch(err => console.log(err));
  }, []);

  const handleWatched = async (id: string) => {
    const body = {
      fileId: id
    }
    const watched = await api.post(`video/watch`, body, {headers: { authorization: abl.token }});
    return watched;
  }

  const handleOnDeleteMovie = async (id: string) => {
    const deleted = await api.delete(`company/video/${id}`);
    if(deleted){
      let movieToDeleteIndex = movies.findIndex((movie: Movie) => movie.id === id);
      let moviesCopy = movies.slice(movieToDeleteIndex, 1);

      setMovies(moviesCopy);
    }
  }

  const handleShowModal = useCallback((id:string, url: string, bucketFilename?: string ) => {
    handleWatched(id);
    let signedUrl: string = ''
    signedUrl = bucketFilename? getFileFromS3(bucketFilename, (60 * 60 * 6)) : url;
    setMovieUrl(signedUrl);
    setShowModal(true);
  }, [showModal])

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, [showModal]);


  return(
    <>
      <WatchMovie show={showModal} url={movieUrl} onClose={handleCloseModal}/>
      <div className="container">
      <h3>FILMES CADASTRADOS</h3>
        <div className="row text-center">
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                <table className="table" width="1150px" /*border="0"*/ /*cellpadding="0" cellspacing="0"*/>
                  <thead>
                  <tr style={{borderBottom:'1', borderWidth:'solid', borderColor:'#f1f1f1'}} >
                    <td width={250} align="left" height="45">
                      <b>NOME DO FILME</b>
                    </td>
                    <td width={700} align="left" height="45">
                      <b>NOME DA PRODUTORA</b>
                    </td>
                    <td width={120} align="center" height="45">
                      <b>DATA DE CADASTRO</b>
                    </td>
                    {abl.roles === 'admin' && (<td width={150} align="center" height="45">
                      <b>EXCLUIR</b>
                    </td>)}
                  </tr>
                  </thead>
                  <tbody>
                    {movies.map((movie: Movie, _) => {
                      return(
                        <tr key={_}>
                          <td align="left" height="45">
                          {
                            abl.roles === 'banca' || abl.roles === 'admin' ?
                            <a href="javascript:void(0)" onClick={()=> handleShowModal(movie.id, movie.url, movie.bucketFilename)}>{movie.movieName}</a>
                            :
                            movie.movieName
                          }
                          </td>
                          <td align="left" height="45">{movie.companyName}</td>
                          <td>{format(new Date(movie.createDate), 'dd/MM/yyyy HH:mm')}</td>

                          {abl.roles === 'admin' && (<td>
                            <a className="btn btn-danger btn-sm" onClick={() => handleOnDeleteMovie(movie.id)}>
                              <i className="glyphicon glyphicon-trash"></i>
                            </a>
                          </td>)}
                        </tr>
                    )})}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
    )
}
